export const commonListAction = {
    SET_DROPDOWN_BRANCH_LIST: "SET_DROPDOWN_BRANCH_LIST",
    SET_CITY_LIST: "SET_CITY_LIST",
    REDIRECT_PARTY_LIST:"REDIRECT_PARTY_LIST"

};